import { FC } from "react";
import { Tooltip } from "./Tooltip";
import styles from "@/styles/pages/software.module.scss";
import { twoDigitsNumber } from "@/utils/helpers";
import { useRouter } from "next/router";
import { FaArrowRight } from "react-icons/fa";

export const ServiceCard: FC<{
  section: { id?: number; title: string; content: string; link?: string };
  position: { x: number; y: number };
  index: number;
}> = ({ section, position, index }) => {
  const { push } = useRouter();

  const navigateToSubpage = (link: string) => {
    link && push(link);
  };
  return (
    <Tooltip text={section.content} number={index + 1} position={position}>
      <div className={`${styles.cardItem}`} onClick={() => navigateToSubpage(section.link)}>
        <span className='mb-2'>{twoDigitsNumber(index + 1)}</span>
        <div>
          <h3 className='bold mb-2'>{section.title}</h3>
          <p className='text-muted truncate'>{section.content}</p>
        </div>
        <FaArrowRight className='text-white fs-4' />
      </div>
    </Tooltip>
  );
};
